import React, { useEffect, useState } from 'react';

// helpers
import { useMainLayoutContext } from 'modules/Layouts/MainLayout/MainLayoutContext';

// components
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import TravelNotificationsTable from '../../modules/Profile/TravelNotifications/TravelNotificationsTable';
import AddTravelNotificationRule from '../../modules/Profile/TravelNotifications/TravelNotificationsTable/AddTravelNotificationModal';

const TravelNotifications = () => {
  const [updateTableTrigger, updateTable] = useState({});
  const { setPageLayoutOptions, clearContext } = useMainLayoutContext();

  useEffect(() => {
    setPageLayoutOptions((prev) => ({
      ...prev,
      extra: <AddTravelNotificationRule onAdd={() => updateTable({})} />,
    }));
    return () => clearContext();
  }, [clearContext, setPageLayoutOptions]);

  return (
    <PageContentCard>
      <TravelNotificationsTable updateTableTrigger={updateTableTrigger} />
    </PageContentCard>
  );
};

export default TravelNotifications;
